<template>
  <div class="flex flex-col ml-1">
    <ChevronUp
      :class="[
        'w-3 h-3 -mb-1',
        currentSort === `-${field}` ? 'text-gray-900' : 'text-gray-300'
      ]"
    />
    <ChevronDown
      :class="[
        'w-3 h-3',
        currentSort === field ? 'text-gray-900' : 'text-gray-300'
      ]"
    />
  </div>
</template>

<script setup lang="ts">
import { ChevronUp, ChevronDown } from 'lucide-vue-next'

defineProps<{
  field: string
  currentSort: string
}>()
</script>

